//start Announcement bar cross code
$(document).ready(function(){
if (!(localStorage.getItem('announceBar'))) {
$('#shopify-section-announcement').css("display","block");
$('.close_announce_bar').click(function() {
 $('#shopify-section-announcement').hide();
  localStorage.setItem('announceBar', true);
});
}
else{
  $('#shopify-section-announcement').css("display","none");
}
// $('.AnnouncementBar__Content').slick({
//     slidesToScroll:1,
//     slidesToShow: 1,
//     autoplay: true,
//     autoplaySpeed:2000,
//     infinite: true,
//     horizontal: true,
//     horizontalSwiping:true,
//     arrows:false
//   }); 
});
//end Announcement bar cross code